import { StyleSheet} from 'aphrodite';

export const styles = StyleSheet.create({
    tooltip: {
        padding: "10px",
        backgroundColor: "white",
        borderRadius: "3px",
        borderColor: "#d1d1d1",
        borderStyle: "solid",
        borderWidth: "1px"
    }
})


// WEBPACK FOOTER //
// ./src/styles/Tooltip.ts